import React, { useEffect, useState, useLayoutEffect } from 'react'
import { useMemo } from 'react';

import { Spinner, Table, Tabs, Tab } from 'react-bootstrap';
// import { createNews } from '../api/admin-api';
import Cookie from 'react-cookies';
import { DeleteForever } from '@mui/icons-material';
import Swal from 'sweetalert2';
import {  getVotees, saveVote, getVoteResults, getVoteConfig, getVoterStatus } from '../../api/api';
import { Select } from '@mui/material';
import { FaCheckCircle, FaThumbsUp } from 'react-icons/fa';
const Vote = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [voterStatus, setVoterStatus] = useState(false);
  const [statusText, setStatusText] = useState(null);
  const [data, setData] = useState(null);
  const [newsImages, setNewsImages] = useState(['/tph_logo.png']);
  const [newsImagesOriginal, setNewsImagesOriginal] = useState();
  const [image, setImage] = useState('/tph_logo.png');
  const [votees, setVotees] = useState(null);
  const [voted, setVoted] = useState({
    juniorM: [{c: null}, {c: null}, {c: null}],
    juniorF: [{c: null}, {c: null}, {c: null}],
    senior: [{c: null}, {c: null}, {c: null}]
  })
  const [SVotees, setSVotees] = useState(null);
  const [MJVotees, setMJVotees] = useState(null);
  const [FJVotees, setFJVotees] = useState(null);
  const [defaultTab, setDefaultTab] = useState('male');
  const  [tabUsed, setTabUsed] = useState({
    male: false,
    female: false,
    senior: false
  });
  const criteria =[
    {
        category: 'Productivity and Impact',
        criteria: 'Result Oriented, Contribution, Technical Knowleadge, Team Player, Performance Under Pressure, Good Communicator.'
    },
    {
        category: 'Behavioral/Work Ethics',
        criteria: 'Customer Service, Integrity,  Perseverance, friendliness, Puntuality, Loyalty et cetera.'
    },
    {
        category: 'Others (Soft Skills)',
        criteria: 'Innovative, Open Minded/Flexible, Capacity to Learn New Skills, Persistency/Consistency.'
    }
  ]
  
  const checkVoterStatus = async () => {
    const res = await getVoterStatus();
    if (res.success) {
        setVoterStatus(true);
    }else{
        // setVoterStatus(false);   
        // navigate('/dashboard');
    }
  }
  const checkVoteStatus = async () => {
    
    const res = await getVoteConfig();
    console.log(res);
    if(res.success){
        Cookie.save('status', false)
        let year = res.data.year;
        let today = new Date('20'+res.data.today).getTime();
        let start = new Date(res.data.start).getTime();
        let end = new Date(res.data.end).getTime();
        console.log(res.data.today);
        console.log(today)
        console.log(start)
        console.log(end)

        if(start <= today && today <= end){
            console.log('Voting is ongoing...')
            setStatus(true);
        }else if(start > today){
            console.log('voting has not yet commence');
            setStatus(false);
            setStatusText('voting has not yet commence');
        }else{
            console.log('voting has ended')
            setStatus(false);
            setStatusText(year +' Voting has ended.');
        }
    }else{
             setStatus(false);
            setStatusText(res.message);
            if(!res.message && !Cookie.load('status')){
                window.location.reload();
                Cookie.save('status', true);
            } 
    }
  }
  const handleInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setData({
      ...data, [name]: value
    })
  }
   const fetchVotees = async () => {
		const response = await getVotees()
        // console.log(response);
		if(response.success){
            setVotees(response.data);
        }
    }
  const handleDisabled = (key) => {

    if(key !== defaultTab){
        return true
    }else{
        return false
    }
  }
  const tabTitle = (key) => {

    if(key === 'male'){
         if(defaultTab === key || !tabUsed.male){
            return "Male Juior"
        }else{
            return <h6> Male Junior <FaCheckCircle /> </h6>
        }
    }else if(key === 'female'){
         if(defaultTab === key || !tabUsed.female){
            return "Female Junior"
        }else{
            return <h6> Female Junior <FaCheckCircle /> </h6>
        }
    }else if (key === 'senior'){
        if(defaultTab === key || !tabUsed.senior){
            return "Senior Staff"
        }else{
            return <h6> Senior Staff <FaCheckCircle /> </h6>
        }
    }

  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    // let formId = document.getElementById('createNewsForm');
    // const formData = new FormData();
    // formData.delete('file []');
    // formData.append('senior', JSON.stringify(['one', 'two']));
    // formData.append('juniorM', voted.juniorM);
    // formData.append('juniorF', voted.juniorF);
    
  const res = await saveVote(voted);
  console.log(res);
  if(res.success){
    Swal.fire({
        title: "Successful",
        text: res.message,
        // timer: 3000,
        icon: 'success',
        confirmButtonColor: '#320808'
    })
    e.target.reset();
    setNewsImages([]);
    setVoterStatus(false);
  }else{
    Swal.fire({
        title: "Failed",
        text: res.message,
        // timer: 3000,
        icon: 'error',
        confirmButtonColor: '#320808'
    })
  }

} 
const fetchVoteResults = async () => {
    const res = await getVoteResults();
    // console.log(res);
}

  useEffect(() => {
    document.title = 'Vote | Taste Place Investment'
    !status && checkVoteStatus();
    checkVoterStatus();
    // fetchVoteResults();
  }, [])
  useEffect(() => {
    status && fetchVotees();
  }, [status])
  useEffect(() => {
    // console.log(voted);
  }, [voted])
  if(voterStatus){
    if(!status) return (
    <div className=' row justify-content-center py-5'>
        {/* <h4> <b className="mb-5 ms-5 text-center">TASTE PLACE Staffs Performance Rating System </b> </h4> */}
        <h3> <p className="mb-5 ms-5 text-center ">{statusText}.</p> </h3>
    </div>
    )
    if (status)return (
        <div className='d-flex justify-content-center align-items-center'
        style={{ 
        backgroundColor: 'whitesmoke'
        }}
        >
        <div className=' container card my-5 mx-4 px-4 '
        
        >
            <div className="">
                <p className="small-header ms-4 mt-4 text-center"> <u>Vote Your Best Staffs of 2025</u> </p>
            <form method='POST' onSubmit={handleSubmit}
            id="createNewsForm"
            >  
            <Tabs variant='tabs' activeKey={defaultTab} onSelect={(k) => setDefaultTab(k)}>
                <Tab eventKey={'male'} 
                title={tabTitle('male')} 
                tabClassName='text-dark'
                disabled={handleDisabled('male')}
                >
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="card mb-4">
                                {
                                    criteria.map((c, i) =>(
                                        <div className="card-body">
                                
                                            
                                            <h4 className='text-center'> {c.category} </h4>
                                            <p className='text-center'><i><small>{c.criteria}</small></i></p>
                                            <div className='row align-items-center my-2 py-2' 
                                            // style={{
                                            //     borderStyle: 'groove',
                                            //     border: '0px',
                                            //     borderBottom: '2px',
                                            //     borderBottomColor: 'red',
                                            //  }}
                                            >
                                                <div className='tableContainer col-lg-9'>
                                                    <table className=' tb table responsive bg-danger'
                                                    // style={{ height: '300px', width: '200px' }}
                                                    onClick={() => setData({...data, c})}
                                                    >
                                                    {/* <select className='form-control form-select'>
                                                        <option> Select Staff... </option> */}
                                                        {votees && votees.filter((v) => v.gender === 'male' && v.category === 'junior').map((votee)=>(
                                                            
                                                                <thead onClick={() => {
                                                                if(i === 0){
                                                                    setVoted(
                                                                        {...voted, juniorM: [
                                                                            {...voted.juniorM[0], c: votee},
                                                                            {...voted.juniorM[1]},
                                                                            {...voted.juniorM[2]}
                                                                            ]
                                                                        }
                                                                    )
                                                                }else if(i === 1){
                                                                    setVoted(
                                                                        {...voted, juniorM: [
                                                                            {...voted.juniorM[0]},
                                                                            {...voted.juniorM[1], c: votee},
                                                                            {...voted.juniorM[2]}
                                                                            ]
                                                                        }
                                                                    )
                                                                }else if(i === 2){
                                                                    setVoted(
                                                                        {...voted, juniorM: [
                                                                            {...voted.juniorM[0] },
                                                                            {...voted.juniorM[1]},
                                                                            {...voted.juniorM[2], c: votee}
                                                                            ]
                                                                        }
                                                                    )
                                                                }
                                                                }}>
                                                                    <tr className='votees text-center'>
                                                                
                                                                    <th>
                                                                        <div>
                                                                            <img
                                                                        src={votee.image}
                                                                        alt={votee.position+" image"}
                                                                        width={80}
                                                                        height={80}
                                                                        />
                                                                        </div>
                                                                        {votee.name +' ('+ votee.position+')'}
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                            
                                                        ))}
                                                    </table>
                                                </div>
                                                <div className=' col-lg-3 text-center'>
                                                
                                                    <div   className='product-container d-flex-column mx-2 justify-content-center align-items-center' 
                                                    style={{
                                                        cursor: "pointer",
                                                        borderRadius:5,
                                                        borderWidth:1,
                                                        borderColor:"#e0e2e3",
                                                    }}
                                                    >
                                                    {
                                                        voted.juniorM[i].c !== null &&
                                                        <>
                                                        <img
                                                            src={voted.juniorM[i].c.image}
                                                            alt={voted.juniorM[i].c.name}
                                                            width={80}
                                                            height={80}
                                                            />
                                                            <h5 className='mb-0'>{voted.juniorM[i].c.name}</h5>
                                                            <small className='mt-0'>{'('+voted.juniorM[i].c.position+')'}</small>
                                                        </>
                                                    }
                                                    </div>
                                                            
                                                </div>
                                            </div>
                                            <hr/>
                                            {/* <small className='text-danger' style={{ 
                                                fontSize: 12
                                            }}> <b>Note: Not more than one image. </b> </small>  */}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        
                        <button 
                        onClick={() => {
                            setTabUsed({...tabUsed, male: true});
                            setDefaultTab('female');
                            window.scrollTo({top: 0, left: 0});
                        }}
                        type='button' 
                        className="btn form-control btn-lg btn-color read-btn mt-2">
                            Continue
                        </button>
                    </div> 
                </Tab>
                <Tab eventKey={'female'} 
                title={tabTitle('female')} 
                tabClassName='text-dark'
                disabled={handleDisabled('female')}
                >
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="card mb-4">
                                {
                                    criteria.map((c, i) =>(
                                        <div className="card-body">
                                
                                            
                                            <h4 className='text-center'> {c.category} </h4>
                                            <p className='text-center'><i><small>{c.criteria}</small></i></p>
                                            <div className='row align-items-center my-2 py-2' 
                                            // style={{
                                            //     borderStyle: 'groove',
                                            //     border: '0px',
                                            //     borderBottom: '2px',
                                            //     borderBottomColor: 'red',
                                            //  }}
                                            >
                                                <div className='tableContainer col-lg-9'>
                                                    <table className=' tb table responsive bg-danger'
                                                    // style={{ height: '300px', width: '200px' }}
                                                    >
                                                    {/* <select className='form-control form-select'>
                                                        <option> Select Staff... </option> */}
                                                        {votees && votees.filter((v) => v.gender === 'female' && v.category === 'junior').map((votee)=>(
                                                            
                                                                <thead onClick={() => {
                                                                if(i === 0){
                                                                    setVoted(
                                                                        {...voted, juniorF: [
                                                                            {...voted.juniorF[0], c: votee},
                                                                            {...voted.juniorF[1]},
                                                                            {...voted.juniorF[2]}
                                                                            ]
                                                                        }
                                                                    )
                                                                }else if(i === 1){
                                                                    setVoted(
                                                                        {...voted, juniorF: [
                                                                            {...voted.juniorF[0]},
                                                                            {...voted.juniorF[1], c: votee},
                                                                            {...voted.juniorF[2]}
                                                                            ]
                                                                        }
                                                                    )
                                                                }else if(i === 2){
                                                                    setVoted(
                                                                        {...voted, juniorF: [
                                                                            {...voted.juniorF[0] },
                                                                            {...voted.juniorF[1]},
                                                                            {...voted.juniorF[2], c: votee}
                                                                            ]
                                                                        }
                                                                    )
                                                                }
                                                                }}>
                                                                    <tr className='votees text-center'>
                                                                
                                                                    <th>
                                                                        <div>
                                                                            <img
                                                                        src={votee.image}
                                                                        alt={votee.position+" image"}
                                                                        width={80}
                                                                        height={80}
                                                                        />
                                                                        </div>
                                                                        {votee.name +' ('+ votee.position+')'}
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                            
                                                        ))}
                                                    </table>
                                                </div>
                                                <div className=' col-lg-3 text-center'>
                                                
                                                    <div   className='product-container d-flex-column mx-2 justify-content-center align-items-center' 
                                                    style={{
                                                        cursor: "pointer",
                                                        borderRadius:5,
                                                        borderWidth:1,
                                                        borderColor:"#e0e2e3",
                                                    }}
                                                    >
                                                    {
                                                        voted.juniorF[i].c !== null && 
                                                        (
                                                            <>
                                                            <img
                                                            src={voted.juniorF[i].c.image}
                                                            alt={voted.juniorF[i].c.name}
                                                            width={80}
                                                            height={80}
                                                            />
                                                            <h5 className='mb-0'> {voted.juniorF[i].c.name} </h5>
                                                            <small className='mt-0'>{'('+voted.juniorF[i].c.position+')'}</small>
                                                            </>
                                                            
                                                        )
                                                    }
                                                    </div>
                                                            
                                                </div>
                                            </div>
                                            <hr/>
                                            {/* <small className='text-danger' style={{ 
                                                fontSize: 12
                                            }}> <b>Note: Not more than one image. </b> </small>  */}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        
                        <button 
                        onClick={() => {
                            setTabUsed({...tabUsed, female: true});
                            setDefaultTab('senior')
                            window.scrollTo({top: 0, left: 0});
                        }}
                        type='button' 
                        className="btn form-control btn-lg btn-color read-btn mt-2">
                            Continue
                        </button>
                    </div> 
                </Tab>
                <Tab eventKey={'senior'} 
                title={tabTitle('senior')} 
                tabClassName='text-dark'
                disabled={handleDisabled('senior')}
                >
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="card mb-4">
                                {
                                    criteria.map((c, i) =>(
                                        <div className="card-body">
                                
                                            
                                            <h4 className='text-center'> {c.category} </h4>
                                            <p className='text-center'><i><small>{c.criteria}</small></i></p>
                                            <div className='row align-items-center my-2 py-2' 
                                            // style={{
                                            //     borderStyle: 'groove',
                                            //     border: '0px',
                                            //     borderBottom: '2px',
                                            //     borderBottomColor: 'red',
                                            //  }}
                                            >
                                                <div className='tableContainer col-lg-9'>
                                                    <table className=' tb table responsive bg-danger'
                                                    // style={{ height: '300px', width: '200px' }}
                                                    onClick={() => setData({...data, c})}
                                                    >
                                                    {/* <select className='form-control form-select'>
                                                        <option> Select Staff... </option> */}
                                                        {votees && votees.filter((v) => v.category === 'senior').map((votee)=>(
                                                            
                                                                <thead onClick={() => {
                                                                if(i === 0){
                                                                    setVoted(
                                                                        {...voted, senior: [
                                                                            {...voted.senior[0], c: votee},
                                                                            {...voted.senior[1]},
                                                                            {...voted.senior[2]}
                                                                            ]
                                                                        }
                                                                    )
                                                                }else if(i === 1){
                                                                    setVoted(
                                                                        {...voted, senior: [
                                                                            {...voted.senior[0]},
                                                                            {...voted.senior[1], c: votee},
                                                                            {...voted.senior[2]}
                                                                            ]
                                                                        }
                                                                    )
                                                                }else if(i === 2){
                                                                    setVoted(
                                                                        {...voted, senior: [
                                                                            {...voted.senior[0] },
                                                                            {...voted.senior[1]},
                                                                            {...voted.senior[2], c: votee}
                                                                            ]
                                                                        }
                                                                    )
                                                                }
                                                                }}>
                                                                    <tr className='votees text-center'>
                                                                
                                                                    <th>
                                                                        <div>
                                                                            <img
                                                                            src={votee.image}
                                                                            alt={votee.position+" image"}
                                                                            width={80}
                                                                            height={80}
                                                                            />
                                                                        </div>
                                                                        {votee.name +' ('+ votee.position+')'}
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                            
                                                        ))}
                                                    </table>
                                                </div>
                                                <div className=' col-lg-3 text-center'>
                                                
                                                    <div   className='product-container d-flex-column mx-2 justify-content-center align-items-center' 
                                                    style={{
                                                        cursor: "pointer",
                                                        borderRadius:5,
                                                        borderWidth:1,
                                                        borderColor:"#e0e2e3",
                                                    }}
                                                    >
                                                    {
                                                        voted.senior[i].c !== null && 
                                                        <>
                                                        <img
                                                            src={voted.senior[i].c.image}
                                                            alt={voted.senior[i].c.name}
                                                            width={80}
                                                            height={80}
                                                            />
                                                            <h5 className='mb-0'>{voted.senior[i].c.name}</h5>
                                                            <small className='mt-0' style={{ marginTop: 0 }}> {'('+voted.senior[i].c.position+')'}</small>
                                                        </>
                                                    }
                                                    </div>
                                                            
                                                </div>
                                            </div>
                                            <hr/>
                                            {/* <small className='text-danger' style={{ 
                                                fontSize: 12
                                            }}> <b>Note: Not more than one image. </b> </small>  */}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        
                    </div>
                    <button 
                    // onClick={handleSubmit}
                    // type='submit' 
                    className="btn form-control btn-lg btn-color read-btn mt-2">
                    {loading ? <Spinner size='md' /> : "Submit Votes"}
                    </button>
                </Tab>
            </Tabs>
            </form>
            </div>
        </div>
        </div>
    )
  }else return (
     <div className=' row justify-content-center py-5'>
        {/* <h4> <b className="mb-5 ms-5 text-center">TASTE PLACE Staffs Performance Rating System </b> </h4> */}
        {/* <h3> <p className="mb-5 ms-5 text-center ">Your vote has been recorded. <p><FaThumbsUp /> </p></p> </h3> */}
        <h3> <p className="mb-5 ms-5 text-center "> Voting has not commence yet!!!  </p> </h3>
    </div>
  )
}

export default Vote
